import React, {useEffect, useRef, useState} from 'react';
import "./PanelInterview.sass"
import apiJSON from "../../../api/apiJSON";
import CheckCircle from "../../../icons/check_circle_inverse.svg";
import renderHTML from "react-render-html";
import Button from "../../ui/Button/Button";
import gsap from "gsap";
import ClickReveal from "../ClickReveal/ClickReveal";

const PanelInterview = ({data, completed, next}) => {

    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [tracking, setTracking] = useState([]);

    const jsonData = apiJSON.get(data);
    const scenario = jsonData.scenario;

    const finish = () => {
        console.log("PanelInterview finish()");
        completed();
    }

    useEffect(() => {
        if (checkCompleted()) {
            finish();
        }
    }, [tracking]);

    const checkCompleted = () => {
        return (tracking.length>0&&tracking.indexOf(0) === -1);
    }

    const handleSelect = (event, index) => {
        console.log("handleSelect(" + index + ")");
        setSelectedIndex(index);
    }

    const handleOutsideClick = (event) => {
        setSelectedIndex(-1);
    }

    const clickRevealCompleted = () => {
        let t = tracking.slice();
        if (t.length == 0) {
            scenario.choiceSet.choices.map((index) => {
                t.push(0)
            });
        }
        t[selectedIndex] = 1;
        setTracking(t)
    }

    const returnToPanel = () =>{
        setSelectedIndex(-1)
    }

    return (
        <div className="PanelInterview">
            {
                (selectedIndex != -1) &&
                <ClickReveal data={scenario.choiceSet.choices[selectedIndex].clickreveal}
                                  completed={clickRevealCompleted}
                                  next={returnToPanel}
                                  key={"clickreveal" + selectedIndex}
                                  showDoneButton={true}/>
            }
            {
                scenario &&
                <div className="panel-interview-main-text">
                    <div className="panel-interview-main-title">
                        {scenario.title}
                    </div>
                    <div className="panel-interview-main-divider"/>
                    <div className="panel-interview-main-body">
                        {renderHTML(scenario.body)}
                    </div>
                </div>
            }
            <div className="click-catcher"
                 onClick={handleOutsideClick}/>
            {
                scenario &&
                <div className="panel-interview-row">
                    {scenario.choiceSet.choices.map((choice, index) => (
                        <div className="panel-interview-item">
                            <div className="panel-interview-thumbnail-holder"
                                 id={"thumbnail" + index}
                                 onClick={(event) => {
                                     handleSelect(event, index)
                                 }}>
                                <div className="panel-interview-thumbnail"
                                     key={"choice" + index}>
                                    <img src={choice.image}/>
                                </div>
                                <div className={"panel-interview-check" + ((tracking.length === 0 || tracking[index] === 0) ? " invisible" : "")}>
                                    <img src={CheckCircle}/>
                                </div>
                            </div>
                            <div className="panel-interview-label"
                                 id={"label" + index}>
                                {renderHTML(choice.label)}
                            </div>
                        </div>
                    ))}
                </div>
            }
        </div>
    );
};

export default PanelInterview;